import gql from 'graphql-tag';

export const RUN_QUEUE_ITEM_FRAGMENT = gql`
  fragment RunQueueItemFragment on RunQueueItem {
    id
    createdAt
    updatedAt
    runSpec
    state
    associatedRunId
    launchAgentId
    priority
    templateVariableValues
  }
`;

export const CREATE_RUN_QUEUE = gql`
  mutation createRunQueue(
    $entityName: String!
    $projectName: String!
    $queueName: String!
    $access: RunQueueAccessType!
    $defaultResourceConfigID: ID
    $prioritizationMode: RunQueuePrioritizationMode!
  ) {
    createRunQueue(
      input: {
        entityName: $entityName
        projectName: $projectName
        queueName: $queueName
        access: $access
        defaultResourceConfigID: $defaultResourceConfigID
        prioritizationMode: $prioritizationMode
      }
    ) {
      success
      queueID
    }
  }
`;

export const UPDATE_RUN_QUEUE = gql`
  mutation updateRunQueue(
    $queueID: ID!
    $defaultResourceConfigID: ID
    $externalLinks: JSONString
  ) {
    updateRunQueue(
      input: {
        queueID: $queueID
        defaultResourceConfigID: $defaultResourceConfigID
        externalLinks: $externalLinks
      }
    ) {
      success
    }
  }
`;

export const ENABLE_RUN_QUEUE_PRIORITIZATION = gql`
  mutation enableRunQueuePrioritization($queueID: ID!) {
    updateRunQueue(input: {queueID: $queueID, prioritizationMode: V0}) {
      success
    }
  }
`;

export const DELETE_RUN_QUEUES = gql`
  mutation deleteRunQueues($queueIDs: [ID!]!) {
    deleteRunQueues(input: {queueIDs: $queueIDs}) {
      success
    }
  }
`;

export const PUSH_TO_RUN_QUEUE = gql`
  mutation pushToRunQueue(
    $queueID: ID!
    $runSpec: JSONString!
    $priority: Int
    $templateVariableValues: JSONString
  ) {
    pushToRunQueue(
      input: {
        queueID: $queueID
        runSpec: $runSpec
        priority: $priority
        templateVariableValues: $templateVariableValues
      }
    ) {
      runQueueItemId
    }
  }
`;

export const DELETE_FROM_RUN_QUEUE = gql`
  mutation deleteFromRunQueue($queueID: ID!, $runQueueItemId: ID!) {
    deleteFromRunQueue(
      input: {queueID: $queueID, runQueueItemId: $runQueueItemId}
    ) {
      success
    }
  }
`;

export const FETCH_RUN_QUEUES = gql`
  query fetchRunQueuesFromProject($entityName: String!, $projectName: String!) {
    project(name: $projectName, entityName: $entityName) {
      id
      runQueues {
        id
        createdAt
        createdBy
        access
        updatedAt
        name
        defaultResourceConfigID
        executorInfo
        runQueueItems {
          edges {
            node {
              id
              ...RunQueueItemFragment
            }
          }
        }
      }
    }
  }

  ${RUN_QUEUE_ITEM_FRAGMENT}
`;

export const FETCH_RUN_QUEUE_BY_NAME = gql`
  query FetchRunQueueByName(
    $entityName: String!
    $projectName: String!
    $runQueueName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runQueue(name: $runQueueName) {
        id
        createdAt
        createdBy
        access
        updatedAt
        name
        defaultResourceConfigID
        executorInfo
        runQueueItems {
          edges {
            node {
              id
              ...RunQueueItemFragment
            }
          }
        }
      }
    }
  }

  ${RUN_QUEUE_ITEM_FRAGMENT}
`;

export const FETCH_RUN_QUEUE_ITEM = gql`
  query FetchRunQueueItemFromProject(
    $entityName: String!
    $projectName: String!
    $runQueueName: String!
    $runQueueItemID: ID!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runQueue(name: $runQueueName) {
        id
        runQueueItem(id: $runQueueItemID) {
          id
          ...RunQueueItemFragment
        }
      }
    }
  }

  ${RUN_QUEUE_ITEM_FRAGMENT}
`;

// Used for checking team membership and admin status
export const TEAM_MEMBERS_QUERY = gql`
  query TeamInfo($entityName: String!) {
    entity(name: $entityName) {
      id
      members {
        id
        username
        name
        admin
      }
    }
  }
`;

export const RUN_DISPLAY_NAME = gql`
  query RunDisplayName(
    $entityName: String!
    $projectName: String!
    $runName: String!
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      run(name: $runName) {
        id
        displayName
      }
    }
  }
`;
